export default {
  age2: '年龄2',
  time2: '时间2',
}